import { $http } from "@/assets/js/appFunc";
import i18n from "@/i18n/index";
/**
 * Get Groups
 * "GET" - get all groups
 * "POST" - get groups using pageNumber and pageSize
 */
export const getRoleList = (context, payload) => {
    const callTypePost = payload && typeof payload === "object";
    const req = {
        type: callTypePost ? "POST" : "GET",
        url: "/identity/tenants/groups",
        data: callTypePost ? payload : null
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                if (!callTypePost) {
                    context.commit("setRoleList", data);
                }
                resolve(data);
            },
            error => reject(error)
        );
    });
};
export const getGroupList = (context, payload) => {
    const url = payload.userId ? `/identity/tenant/appGroup/searchGroups?userId=${payload.userId}` : "/identity/tenant/appGroup/searchGroups";
    const req = {
        type: "POST",
        url,
        data: payload
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => reject(error)
        );
    });
};

// delete after roles permissions inplementation
export const createRole = (context, newRole) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/group/admin-ui",
        data: newRole
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                newRole.id = data.data.id;
                context.commit("setRoleList", { addNewRole: true, data: newRole });
                resolve(data);
            },
            error => reject(error)
        );
    });
};

// delete after roles permissions inplementation

export const saveEditRole = (context, dataToSave) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/group/admin-ui",
        data: dataToSave
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                dataToSave.disabledDatetime = data && data.data && data.data.disabledDatetime ? data.data.disabledDatetime : null;
                context.commit("setRoleList", { data: dataToSave });
                resolve(data);
            },
            error => reject(error)
        );
    });
};

// Add/Edit Group - save details with new role permissions system
export const saveAddEditGroup = (context, dataToSave) => {
    const { payload } = dataToSave;
    const req = {
        type: "POST",
        url: "/identity/tenants/group/admin-ui/saveGroupWithRoles",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                payload.disabledDatetime = data && data.data && data.data.disabledDatetime ? data.data.disabledDatetime : null;
                if (!payload.id) { payload.id = data.data.id; }
                context.commit("setRoleList", { addNewRole: dataToSave.addNewGroup, data: payload });
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const deleteRole = (context, role) => {
    delete role.__index;
    role.active = false;
    const req = {
        type: "POST",
        url: "/role",
        data: role
    };
    $http(req).then(
        () => { context.commit("deleteRole", role); },
        error => console.log(error)
    );
};

export const editRole = (context, role) => {
    delete role.__index;
    const req = {
        type: "POST",
        url: "/role",
        data: role
    };
    $http(req).then(
        () => {},
        error => console.log(error)
    );
};

export const addUsersToARole = (context, payload) => {
    const req = {
        type: "PUT",
        url: `/role/${payload.role.id}/role-users`,
        data: payload.users.map(user => user.id)
    };
    $http(req).then(
        () => { context.commit("resetUsers"); },
        error => console.log(error)
    );
};

export const changeUserRoles = (state, payload) => {
    payload.role.users = payload.users;
};

export const getPermissionsForRole = (context, respData) => {
    if (respData.permissionsList.groupPermissionDtos) {
        context.commit("setCurrentPermissionsForRole", respData.permissionsList);
    } else {
        const req = {
            type: "GET",
            url: `/identity/tenants/group/admin-ui/${respData.roleId}`
        };
        $http(req, true).then(
            data => {
                context.commit("setPermissionsRoleList", { response: data.data.permissions || [] });
                context.commit("setCurrentPermissionsForRole", data.data.permissions || []);
            },
            error => console.log(error)
        );
    }
};

export const getCurrentRoleEditedDetails = (context, respData) => {
    const req = {
        type: "GET",
        url: `/identity/tenants/group/admin-ui/${respData.roleId}`
    };
    return $http(req, true).then(
        data => {
            const directPermTranslation = {};
            const changeIds = (dataPermissions) => {
                const newData = [];
                if (dataPermissions) {
                    dataPermissions.forEach(appData => {
                        const newIds = [];
                        const { targetId, id } = appData;
                        const appId = targetId || id;
                        if (!directPermTranslation[appId]) {
                            directPermTranslation[appId] = {};
                        }
                        appData.roles.forEach(elem => {
                            if (elem.code === "INITIATOR" && elem.id) {
                                newIds.push(elem);
                                directPermTranslation[appId][elem.id] = `${i18n.t("applicationPermissions.INITIATORTitle")} "${elem.name}"`;
                            } else {
                                newIds.push(elem);
                                directPermTranslation[appId][elem.code] = elem.name;
                            }
                        });
                        newData.push({ ...appData, roles: newIds });
                    });
                }
                return newData.length ? newData : dataPermissions;
            };
            const changeData = (v) => {
                const directAppDetailAndRoles = changeIds(v.directAppDetailAndRoles);
                const inheritedProcessDetailsAndRoles = changeIds(v.inheritedProcessDetailsAndRoles);
                return { ...v, directAppDetailAndRoles, inheritedProcessDetailsAndRoles };
            };
            const dataFormated = changeData(data.data);
            context.commit("setPermissionsRoleList", { response: dataFormated.permissions || [] });
            context.commit("setCurrentPermissionsForRole", dataFormated.permissions || []);
            context.commit("setUserRoleList", { response: dataFormated.users || [] });
            context.commit("setCurrentUsersForRole", dataFormated.users || []);
            context.commit("setCurrentMembersForGroup", dataFormated.members || []);
            context.commit("setParentsGroupSelected", dataFormated.parents || []);
            context.commit("setPermissionsRolesGroupSelected", {
                directPermTranslation,
                directPermissions: dataFormated.directAppDetailAndRoles,
                inheritedPermissions: dataFormated.inheritedProcessDetailsAndRoles
            } || []); // PERMISSISONS:new Permissions System
        },
        error => console.log(error)
    );
};

/* add role on user */
export const addRolesToUser = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/users",
        data: payload.dataRoles
    };
    $http(req, true).then(
        () => {
            context.commit("setRolesUserList", { response: payload.dataRoles, userId: payload.userId });
        },
        error => console.log(error)
    );
};

export const getRolesForUser = (context, respData) => {
    const req = {
        type: "GET",
        url: `/identity/tenants/users/admin-ui/${respData.userId}`
    };
    $http(req, true).then(
        data => {
            context.commit("setRolesUserList", { response: data.data.groups || [] });
            context.commit("setCurrentRolesForUser", data.data.groups || []);
        },
        error => console.log(error)
    );
};

// Manage Groups Application
// get Groups List
export const actionGetGroupsApps = (context) => {
    // let processDefinitionId = context.state.currentApp.id;
    const applicationId = context.rootState.main.currentApplicationId;
    if (applicationId) {
        const req = {
            type: "GET",
            url: `/identity/tenant/appGroups?applicationId=${applicationId}`
        };
        $http(req, true).then(
            data => {
                if (data && data.data) {
                    data.data.forEach(element => {
                        if (element.type === "TPD") {
                            element.nrOfGroups = element.members && element.members[0] ? element.members[0].nrOfGroups : 0;
                            element.nrOfUsers = element.members && element.members[0] ? element.members[0].nrOfUsers : 0;
                        }
                    });
                }
                context.commit("setGroupsAppList", data);
            },
            error => console.log(error)
        );
    }
};

// update group Application
export const updateCreateGroupApp = (context, dataToSave) => {
    if (dataToSave.fromAdmin) {
        dataToSave.applicationId = context.rootState.main.currentApplicationId;
    }
    const req = {
        type: "POST",
        url: "/identity/tenant/appGroup",
        data: dataToSave
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                dataToSave.disabledDatetime = data && data.data && data.data.disabledDatetime ? data.data.disabledDatetime : null;
                if (!dataToSave.fromAdmin) {
                    context.commit("setRoleList", { data: dataToSave });
                } else {
                    dataToSave.id = data.data.id;
                    if (!dataToSave.hasOwnProperty("type")) { dataToSave.type = "TPD"; }
                    context.commit("updateRoleList", { data: dataToSave });
                    context.commit("setRoleList", { data: dataToSave, addNewRole: !dataToSave.editType });
                }
                resolve(data);
            },
            error => reject(error)
        );
    });
};

// get Group Details Application
export const getGroupDetailsApps = (context, payload) => {
    const req = {
        type: "GET",
        url: `/identity/tenant/appGroup/${payload.groupId}`
    };
    return $http(req, true).then(
        data => {
            const directPermTranslation = {};
            const changeIds = (dataPermissions) => {
                const newData = [];
                if (dataPermissions) {
                    dataPermissions.forEach(appData => {
                        const newIds = [];
                        const { targetId, id } = appData;
                        const appId = targetId || id;
                        if (!directPermTranslation[appId]) {
                            directPermTranslation[appId] = {};
                        }
                        appData.roles.forEach(elem => {
                            if (elem.code === "INITIATOR" && elem.id) {
                                newIds.push(elem);
                                directPermTranslation[appId][elem.id] = `${i18n.t("applicationPermissions.INITIATORTitle")} "${elem.name}"`;
                            } else {
                                newIds.push(elem);
                                directPermTranslation[appId][elem.code] = elem.name;
                            }
                        });
                        newData.push({ ...appData, roles: newIds });
                    });
                }
                return newData.length ? newData : dataPermissions;
            };
            const changeData = (v) => {
                const directAppDetailAndRoles = changeIds(v.directAppDetailAndRoles);
                const inheritedProcessDetailsAndRoles = changeIds(v.inheritedProcessDetailsAndRoles);
                return { ...v, directAppDetailAndRoles, inheritedProcessDetailsAndRoles };
            };
            const dataFormated = changeData(data.data);
            context.commit("setCurrentGroupSelected", dataFormated);
            context.commit("setAppGroupsInitialData", dataFormated);
            context.commit("setPermissionsRolesGroupSelected", {
                directPermTranslation,
                directPermissions: dataFormated.directAppDetailAndRoles,
                inheritedPermissions: dataFormated.inheritedProcessDetailsAndRoles
            } || []); // PERMISSISONS:new Permissions System
        },
        error => console.log(error)
    );
};

// get all group members
export const getGroupMembers = (context, groupId) => {
    const req = {
        type: "GET",
        url: `/identity/tenant/appGroup/${groupId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data ? data.data : []);
            },
            error => {
                reject(error);
            }
        );
    });
};

// get all members on load and get members on search
export const getMembersLoadSearch = (context, dataRequest) => {
    const applicationId = dataRequest.processDefinitionId || context.rootState.main.currentApplicationId || "CORE";
    const addApplicationId = applicationId && applicationId !== "CORE" ? `&applicationId=${applicationId}` : "";
    const addGroupId = dataRequest.groupId ? `&groupId=${dataRequest.groupId}` : "";
    const addSearchValue = dataRequest.searchValue ? `?searchInput=${encodeURIComponent(dataRequest.searchValue)}` : "";
    const addManager = dataRequest.isManager ? `&isManager=${dataRequest.isManager}` : "";
    const pagination = dataRequest.pagination ? `&pageNumber=${dataRequest.pageNumber}&pageSize=${dataRequest.pageSize}` : "";
    let addQueryParam = addSearchValue + addApplicationId + addGroupId + addManager + pagination;
    if (addQueryParam) {
        addQueryParam = `?${addQueryParam.substr(1)}`;
    }
    const req = {
        type: "GET",
        url: ""
    };
    if (dataRequest.fromProcessInspector) {
        const getUrl = () => {
            let url;
            if (dataRequest.perspectiveId) {
                url = "perspective";
                addQueryParam += `&perspectiveId=${dataRequest.perspectiveId}`;
            } else {
                url = "processInspector";
            }
            return url;
        };
        req.url = `/identity/tenant/appGroup/${getUrl()}/searchMember${addQueryParam}`;
    } else if (dataRequest.fromPermissions) {
        req.url = `/identity/tenant/appGroup/permissions/searchMember${addQueryParam}`;
    } else {
        req.type = "POST";
        req.url = "/identity/tenant/appGroup/searchMember";
        req.data = {
            searchValue: dataRequest.searchValue || null,
            applicationId: applicationId && applicationId !== "CORE" ? applicationId : null,
            parentGroupId: dataRequest.groupId || null,
            isManager: dataRequest.isManager || null,
            pageSize: dataRequest.pageSize || 50,
            pageNumber: dataRequest.pageNumber || 0
        };
    }

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data ? data.data : []);
            },
            error => {
                reject(error);
            }
        );
    });
};

// get member group details
export const getMemberGroupDetails = (context, groupId) => {
    const req = {
        type: "GET",
        url: `/identity/tenant/appGroup/${groupId}/members`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data ? data.data : []);
            },
            error => {
                reject(error);
            }
        );
    });
};
